import { render, staticRenderFns } from "./DashboardContainer.vue?vue&type=template&id=54afccd0&scoped=true&"
import script from "./DashboardContainer.vue?vue&type=script&lang=js&"
export * from "./DashboardContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54afccd0",
  null
  
)

export default component.exports